import enums from '../enums/RdsLife.enums';
export default class RdsUser {
  constructor({ id, name, badge, photos, experience, contacts, info, skills, education, likes, notificationsTopics, notificationsReaded, telegram }) {
    this.id = id;
    this.name = name;
    this.badge = badge;
    this.photos = photos || [];
    this.experience = experience || [];
    this.contacts = contacts || [];
    this.info = info || [];
    this.skills = skills || [];
    this.education = education || [];
    this.tipologia = enums.modelTypes.RDS_USER;
    this.likes = likes || { dishes: [], events: [], products: [] };
    this.notificationsTopics = notificationsTopics || [];
    this.notificationsReaded = notificationsReaded || [];
    this.telegram = telegram;
  }
}
